import EnumSet from 'Services/enumSet'

interface IQuotationType extends EnumSet {
  none: number
  special: number
  smart: number
  public: number
}

const quotationType = new EnumSet({
  none: { value: 0, description: 'Sem origem' },
  special: { value: 1, description: 'Cotação especial' },
  smart: { value: 2, description: 'Cotação inteligente' },
  profile: { value: 3, description: 'Cotação perfil' },
}) as IQuotationType

export default quotationType